import React, { useMemo } from 'react';
import type { CardPreviewPaneProps, GalleryAsset } from '../GenericPreviewPane';
import { AssetContainer, GenericPreviewPane } from '../GenericPreviewPane';
import { CardPreviewFavoriteButton } from '../CardCustomizationContent/CardPreviewFavoriteButton';
import { useCardPreviewPaneAssets } from '../useCardPreviewPaneAssets';
import { PremiumPDPReveal } from './PremiumPDPReveal';
import { Flex } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

export const CardPreviewPane = (props: CardPreviewPaneProps) => {
  const { tq } = useTranslation('stationery');
  const { cardJson, thumbnailUrl, eventId, templateId, isFavorite, themeId, templateCategory } = props;
  const extraAssets = useCardPreviewPaneAssets('wedding', templateCategory, 'joy_digital');

  const previewContent = useMemo(() => {
    return (
      <Flex
        flexDirection="column"
        marginY={7}
        marginX="auto"
        width="100%"
        alignItems="center"
        marginTop={-32}
      >
        <PremiumPDPReveal cardJSON={cardJson} />
      </Flex>
    );
  }, [cardJson]);

  const assets: Array<GalleryAsset> = useMemo(() => {
    return [
      {
        render: () => {
          return (
            <AssetContainer
              key="cardFront"
              label={tq`Front of the Card`}
              enforceAspectRatio={true}
              badge={
                <CardPreviewFavoriteButton
                  themeId={themeId}
                  templateCategory={templateCategory}
                  eventId={eventId || ''}
                  templateId={templateId}
                  isFavorite={isFavorite}
                />
              }
            >
              {previewContent}
            </AssetContainer>
          );
        },
        thumbnailUrl: thumbnailUrl,
      },
      ...extraAssets,
    ];
  }, [tq, thumbnailUrl, extraAssets, themeId, templateCategory, eventId, templateId, isFavorite, previewContent]);

  return (
    <GenericPreviewPane
      {...props}
      assets={assets}
    />
  );
};
